import React, { useState, useEffect } from 'react';
import { Box, VStack, Container } from '@chakra-ui/react';
import Header from './components/Header';
import PresaleStats from './components/PresaleStats';
import TokenomicsChart from './components/TokenomicsChart';
import ErrorDisplay from './components/ErrorDisplay';
import Footer from './components/Footer';
import useEthPrice from './hooks/useEthPrice';
import useWalletBalance from './hooks/useWalletBalance';
import tokenomicsData from './data/tokenomics.json';
import { calculateTokenomics } from './utils/calculations';

function App() {
  const { ethPrice, isLoadingPrice, error: priceError } = useEthPrice();
  const { totalContributedEth, isLoadingBalance, error: balanceError } = useWalletBalance();
  const [tokenomics, setTokenomics] = useState(null);
  
  // We're not tracking individual transactions, so we'll estimate unique contributors
  // based on average contribution size
  const estimatedUniqueContributors = Math.max(
    1,
    Math.round(totalContributedEth / 0.05) // Assuming average contribution of 0.05 ETH
  );

  // Calculate tokenomics when data changes
  useEffect(() => {
    if (ethPrice && !isNaN(totalContributedEth)) {
      console.log('Calculating tokenomics with:', {
        ethPrice,
        totalContributedEth,
        estimatedUniqueContributors
      });
      
      const calculatedTokenomics = calculateTokenomics(
        tokenomicsData,
        ethPrice,
        totalContributedEth,
        estimatedUniqueContributors
      );
      
      setTokenomics(calculatedTokenomics);
    }
  }, [ethPrice, totalContributedEth, estimatedUniqueContributors]);

  const isLoading = isLoadingPrice || isLoadingBalance;
  const error = priceError || balanceError;

  return (
    <Box className="bg-pattern" minH="100vh">
      <Header />
      <Container maxW="1200px" py={8}>
        <VStack spacing={8} align="stretch">
          <ErrorDisplay error={error} />
          
          <PresaleStats 
            ethPrice={ethPrice}
            totalContributedEth={totalContributedEth}
            uniqueContributors={estimatedUniqueContributors}
            isLoading={isLoading}
            tokenomics={tokenomics}
          />
          
          <TokenomicsChart 
            tokenomics={tokenomics} 
            isLoading={isLoading} 
          />
        </VStack>
      </Container>
      <Footer />
    </Box>
  );
}

export default App;